(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHeader(header) {
      var section = header.closest('.shopify-section') || header.parentElement;
      var nav = header.querySelector('[data-ac-nav]');
      var megaToggle = header.querySelector('[data-ac-mega-toggle]');
      var mega = header.querySelector('[data-ac-mega]');
      var drawerToggle = header.querySelector('[data-ac-drawer-toggle]');
      var drawer = header.querySelector('[data-ac-drawer]');

      // No desktop só a barra de navegação fica fixa; no celular (sem essa barra)
      // fica fixa a linha do logo. A seção inteira gruda com deslocamento negativo
      // igual à altura do que deve sumir ao rolar.
      var masthead = header.querySelector('.ac-masthead');
      function updateStickyOffset() {
        if (!section) return;
        var anchor = nav && nav.offsetParent !== null ? nav : masthead;
        if (!anchor) return;
        section.style.setProperty('--ac-sticky-offset', -anchor.offsetTop + 'px');
      }
      updateStickyOffset();
      window.addEventListener('resize', updateStickyOffset);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateStickyOffset);

      // Header fixo: no desktop o logo aparece na barra de navegação; no celular a
      // busca vira um ícone. O modo compacto do celular entra um pouco depois do
      // ponto de fixação e sai antes, para a troca de altura não ficar piscando.
      var searchToggle = header.querySelector('[data-ac-search-toggle]');
      var search = header.querySelector('.ac-search');
      var mobileQuery = window.matchMedia('(max-width: 960px)');
      var ticking = false;
      // Ponto (scrollY) em que o header gruda. Elemento sticky muda de posição
      // quando fixo, então o valor só é medido enquanto ele ainda está no fluxo.
      var cachedPoint = null;
      function stickPoint() {
        var anchor = nav && nav.offsetParent !== null ? nav : masthead;
        var offset = anchor ? anchor.offsetTop : 0;
        var top = section.getBoundingClientRect().top;
        if (top > -offset + 1) cachedPoint = window.scrollY + top + offset;
        else if (cachedPoint === null) cachedPoint = offset; // já carregou rolado: header no topo do documento
        return cachedPoint;
      }
      window.addEventListener('resize', function () {
        cachedPoint = null;
      });
      function setSearchOpen(open) {
        if (!searchToggle) return;
        header.classList.toggle('is-search-open', open);
        searchToggle.setAttribute('aria-expanded', String(open));
        searchToggle.setAttribute('aria-label', open ? 'Fechar busca' : 'Abrir busca');
        if (open) {
          var input = search && search.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
      function updateStuck() {
        ticking = false;
        var y = window.scrollY;
        var point = stickPoint();
        var stuck = header.classList.contains('is-stuck');
        var next = mobileQuery.matches ? (stuck ? y > point + 40 : y > point + 120) : y > point;
        if (next === stuck) return;
        header.classList.toggle('is-stuck', next);
        if (!next) setSearchOpen(false);
        placeStuckItems();
      }

      // Desktop: com o header fixo só a barra de navegação fica visível, então a
      // busca e as ações (orçamento, conta, carrinho) passam para ela e voltam
      // ao topo quando a página sobe de novo.
      var navInner = nav && nav.querySelector('.ac-nav__inner');
      var actions = header.querySelector('.ac-masthead__actions');
      var searchHome = search && { parent: search.parentNode, next: search.nextSibling };
      var actionsHome = actions && { parent: actions.parentNode, next: actions.nextSibling };
      function placeStuckItems() {
        if (!navInner || !search || !actions) return;
        var inNav = header.classList.contains('is-stuck') && !mobileQuery.matches;
        if (inNav === (search.parentNode === navInner)) return;
        if (inNav) {
          navInner.appendChild(search);
          navInner.appendChild(actions);
        } else {
          searchHome.parent.insertBefore(search, searchHome.next);
          actionsHome.parent.insertBefore(actions, actionsHome.next);
        }
      }
      placeStuckItems();
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStuck);
      }, { passive: true });
      mobileQuery.addEventListener('change', function () {
        updateStuck();
        placeStuckItems();
      });
      updateStuck();
      if (searchToggle) {
        searchToggle.addEventListener('click', function () {
          setSearchOpen(!header.classList.contains('is-search-open'));
        });
      }

      function setMega(open) {
        if (!megaToggle || !mega) return;
        megaToggle.setAttribute('aria-expanded', String(open));
        mega.hidden = !open;
      }

      if (megaToggle && mega) {
        megaToggle.addEventListener('click', function () {
          setMega(megaToggle.getAttribute('aria-expanded') !== 'true');
        });
        document.addEventListener('click', function (event) {
          if (!nav.contains(event.target)) setMega(false);
        });
      }

      function setDrawer(open) {
        if (!drawer || !drawerToggle) return;
        drawer.hidden = !open;
        drawerToggle.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('ac-lock', open);
        if (open) {
          var close = drawer.querySelector('.ac-drawer__close');
          if (close) close.focus();
        } else {
          drawerToggle.focus();
        }
      }

      if (drawerToggle && drawer) {
        drawerToggle.addEventListener('click', function () {
          setDrawer(true);
        });
        drawer.querySelectorAll('[data-ac-drawer-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            setDrawer(false);
          });
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (mega && !mega.hidden) {
          setMega(false);
          megaToggle.focus();
        }
        if (drawer && !drawer.hidden) setDrawer(false);
        if (header.classList.contains('is-search-open')) {
          setSearchOpen(false);
          searchToggle.focus();
        }
      });
    }

    document.querySelectorAll('[data-ac-header]').forEach(initHeader);
  })();

  } catch(e) { console.error(e); }
})();
})();
